/* IE11 Polyfill, instead of Babel-polyfill 
import 'core-js/fn/array/from.js';
import 'core-js/fn/array/find.js';
import 'core-js/fn/array/find-index';
import 'core-js/fn/object/entries';
import 'core-js/fn/number/is-integer';
import "core-js/fn/symbol/iterator.js";
import "core-js/es6/symbol.js";
import 'core-js/es6/string';
import 'url-search-params-polyfill';
 */

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";
import "./assets/css/index.css";
import { Provider } from "react-redux";
import routes from "./routes";
import store from "./store/configureStore";
import userManager from "./utils/userManager";
import { OidcProvider } from "redux-oidc";
import NotificationProvider from "./providers/NotificationProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import ThemeProvider from "utils/themes/ThemeProvider";
import "./utils/i18n";
import { BrowserRouter } from "react-router-dom";
import LogoutProvider from "providers/LogoutProvider";
import AuthApolloProvider from "apollo/AuthApolloProvider";
import { GlobalCacheManagerProvider } from "providers/GlobalCacheManager";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <AuthApolloProvider>
        <ThemeProvider>
          <LogoutProvider userManager={userManager}>
            <BrowserRouter>
              <GlobalCacheManagerProvider>
                <ErrorBoundary>
                  <OidcProvider store={store} userManager={userManager}>
                    <NotificationProvider>{routes}</NotificationProvider>
                  </OidcProvider>
                </ErrorBoundary>
              </GlobalCacheManagerProvider>
            </BrowserRouter>
          </LogoutProvider>
        </ThemeProvider>
      </AuthApolloProvider>
    </OidcProvider>
  </Provider>
);

//--relate to https://github.com/facebook/create-react-app/issues/5316
serviceWorker.unregister();
